<template>
    <div>
        <!-- <v-breadcrumbs :items="items" class="breadcrumb">

        </v-breadcrumbs> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style=";margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <webinar_tools></webinar_tools>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                <v-text-field label="Enter Title" rounded outlined dense v-model="title"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                <v-text-field label="Enter Description" rounded outlined dense v-model="description"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                <v-text-field rounded outlined dense v-model="webinarlink" @change="validateWebinarURL(webinarlink)"
                    label="Enter Webinar Link"></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" class="pt-0 mt-0">
                <!-- Webinar Date : <input type="date" id="datePickerId" v-model="date" /> -->
                <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Start Datetime" v-model="date"
                    persistent></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 mt-0">
                <!-- From Time :
                    <input type="time" v-model="fromtime" class="mr-5" />
                    To Time :
                    <input type="time" v-model="totime" /> -->
                <v-datetime-picker clearable dateFormat="dd-MM-yyyy" label="Select End Datetime" v-model="end_date"
                    persistent></v-datetime-picker>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="title && description && date && end_date && webinarlink">
            <v-btn @click="savewebinar" class="button" :loading="publishLoader">Publish / Update</v-btn>
            <v-btn @click="reset" class="button">Reset</v-btn>
        </v-row>
        <v-data-table :headers="headers" :items="webinarlist" class="elevation-1 mytable" dense item-key="wid">
            <template v-slot:top>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Webinar List </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <!-- <v-btn :loading="attendance_loader" @click="getAttandanceMatrix">List</v-btn> -->
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
            </template>
            <template v-slot:[`item.division`]="{ item }">
                <span v-if="item.division.length == 0 ||item.division.length==null  ">
                    --
                </span>
                <span v-else>
                    {{item.division}}
                </span>
            </template>
            <template v-slot:[`title`]="{ item }">
                {{item.title}}
            </template>
            <template v-slot:[`item.isactive`]="{ item }">
                <v-switch v-model="item.isactive" :color="item.isactive?'#0f2027':'gray'"
                    @change="toggle(item)"></v-switch>
            </template>
            <template v-slot:[`item.link`]="{ item }">
                <span v-if="item.webinar_link">
                    <a :href="item.webinar_link" target="_blank">
                        <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                    </a>
                    <br />
                    <span style="opacity: 0.5;">{{item.webinar_link}}</span>
                </span>
            </template>
            <template v-slot:[`item.edit`]="{ item }">
                <span>
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editWebinar(item)">
                            edit
                        </v-icon>
                    </v-avatar>
                </span>
            </template>
            <template v-slot:[`item.copy`]="{ item }">
                <v-icon class="mr-2 v-icon-size" @click="copywebinar(item.wid)"
                    color="success">mdi-content-copy</v-icon>
            </template>
            <template v-slot:[`item.view`]="{item}">
                <span v-if="item.file_link!=null">
                    <a :href="item.file_link" target="_blank">
                        <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
                    </a>
                </span>
                <span v-else>--</span>
            </template>
            <template v-slot:[`item.upload`]="{ item }">
                <span>
                    <v-icon @click="uploadvideo(item.wid)" class="mr-2 v-icon-size"
                        color="primary">mdi-cloud-upload</v-icon>
                </span>
            </template>
            <template v-slot:[`item.attendance`]="{ item }">
                <span>
                    <v-icon color="success" @click="getwebinarattendance(item.wid)" class="mr-2">mdi-account-check
                    </v-icon>
                </span>
            </template>
        </v-data-table>
        <!-- </v-card> -->
        <v-dialog class="padding-bot" v-model="dialog_showattendance" persistent max-width="1000px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Webinar Attendance</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn class="toolbar" @click="ExportToExcel1"><v-icon>mdi-file-excel</v-icon>Export</v-btn>
                </v-toolbar>
                <v-card class="box">
                    <v-simple-table class="elevation-1" v-if="learnerprogress!=''" id="mytable1">
                        <template>
                            <thead>
                                <tr>
                                    <th class="text-left">Sr. No.</th>
                                    <th class="text-left">PRN NO</th>
                                    <th class="text-left">Roll NO</th>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Division</th>
                                    <th class="text-left">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,i) in learnerprogress" :key="item">
                                    <td>{{i+1}}</td>
                                    <td>{{item.grno}}</td>
                                    <td>{{item.rollno}}</td>
                                    <td>{{item.name}}</td>
                                    <td>
                                        <span v-if="item.division == null">
                                            --
                                        </span>
                                        <span v-else>{{item.division}}</span>
                                    </td>

                                    <td>
                                        <span v-if="item.isattended == true">
                                            <label>P</label>
                                        </span>
                                        <span v-else> <label>A</label></span>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-row justify="center" v-else>
                        <label><b>No Data Available</b></label>
                    </v-row>
                </v-card>
                <center><v-btn class="button" @click="dialog_showattendance = false">Close</v-btn></center>
            </v-card>
        </v-dialog>
        <v-dialog class="padding-bot" v-model="dialog_uploadvideo" persistent max-width="750px">
            <v-card>
                <v-toolbar class="toolbar" dense flat>
                    <v-toolbar-title>Upload Webinar Video</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card class="box">
                    <v-row class="justify-center">
                        <input type="hidden" name="wid" v-model="wid" />
                        <!-- <v-col cols="12" lg="6" sm="4"></v-col> -->
                        <v-col cols="12" lg="6" sm="6">
                            <span class="video-title">Use Video</span>
                            <div class="video-panel">
                                <div v-if="videoUpload">
                                    <span class="mr-3">{{videoUpload.name}}</span><span><i class="mdi mdi-window-close"
                                            @click="videoUpload=''"></i></span>
                                </div>
                                <v-file-input outlined dense rounded prepend-icon="mdi-cloud-upload"
                                    v-model="videoUpload" accept="video/*" @change="validateFile()"></v-file-input>
                                <p class="v-info">Choose a file to upload</p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn class="button" v-if="videoUpload" @click="uploadvideo1(wid)"
                            :loading="loader">Upload</v-btn>
                    </v-row>
                </v-card>
                <center><v-btn class="button" @click="dialog_uploadvideo = false">Close</v-btn></center>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_copywebinar" persistent max-width="1350px">
            <v-card>
                <v-toolbar class="toolbar" dense flat>
                    <v-toolbar-title>Upload Webinar Video</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card class="box">
                    <v-row justify="center">
                        <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                            <v-text-field label="Enter Title" rounded outlined dense v-model="title"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                            <v-text-field label="Enter Description" rounded outlined dense
                                v-model="description"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-5 mt-1">
                            <v-text-field rounded outlined dense v-model="webinarlink"
                                @change="validateWebinarURL(webinarlink)" label="Enter Webinar Link"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="3" md="3" class="pt-0 mt-0">
                            <!-- Webinar Date : <input type="date" id="datePickerId" v-model="date" /> -->
                            <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Start Datetime" v-model="date"
                                persistent></v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 mt-0">
                            <!-- From Time :
                            <input type="time" v-model="fromtime" class="mr-5" />
                            To Time :
                            <input type="time" v-model="totime" /> -->
                            <v-datetime-picker clearable dateFormat="dd-MM-yyyy" label="Select End Datetime"
                                v-model="end_date" persistent></v-datetime-picker>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="title && description && date && end_date  && webinarlink">
                        <v-btn @click="savewebinar_copy" class="button" :loading="publishLoader">Publish</v-btn>
                        <v-btn @click="reset" class="button">Reset</v-btn>
                    </v-row>
                </v-card>
                <center><v-btn class="button" @click="dialog_copywebinar = false">Close</v-btn></center>
            </v-card>
        </v-dialog>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Publish Course Webinar Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/V15AAN3sxII?si=SnxDtJyvWSHoe-PE"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import webinar_tools from "./Webinar-Tools";
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import datetime from "vuejs-datetimepicker";
    import moment from "moment";
    export default {
        props: ['webinarlist'],
        components: {
            webinar_tools: webinar_tools,
            Datepicker,
            datetime,
        },
        data: () => ({
            coff_id: null,
            items: [
                { text: "Home", disabled: false, href: "/home-updated" },
                { text: "Publish Webinar", disabled: true, href: "" },
            ],
            crs_off_inst_id: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            videoDialog:false,
            title: null,
            description: null,
            date: null,
            end_date: null,
            webinarlink: null,
            fromtime: null,
            totime: null,
            isvalid: false,
            publishLoader: false,
            attendance_loader: false,
            dialog_showattendance: false,
            dialog_uploadvideo: false,
            //webinarlist: [],
            learnerprogress: [],
            videoSizeFlag: false,
            videoTypeFlag: false,
            loader: false,
            imagesize: null,
            imagetype: null,
            videoUpload: null,
            wid: null,
            dialog_copywebinar: false,
            headers: [
                { text: "Course", value: "course_name" },
                { text: "Title", value: "title" },
                { text: "Start Date", value: "webinar_date" },
                { text: "End Date", value: "end_date" },
                { text: "Active", value: "isactive" },
                { text: "Webinar-Link", value: "link", align: "center" },
                { text: "Edit", value: "edit" },
                { text: "View", value: "view", align: "center" },
                { text: "Copy", value: "copy", align: "center" },
                { text: "Upload", value: "upload", align: "center" },
                { text: "Attendance", value: "attendance", align: "center" },
            ],
        }),

        mounted() {
            this.coff_id = this.$store.getters.coff_id;
            this.crs_off_inst_id = this.$store.getters.crs_off_inst_id;
            this.ay = this.$store.getters.ay;
            //this.onload();
        },
        methods: {
            ExportToExcel1(mytblId) {
                var htmltable = document.getElementById("mytable1");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
            validateFile() {
                let file = this.videoUpload;
                let file_size = file.size;
                let file_name = this.videoUpload.name;
                let ext = file_name.split(".").pop();
                const data = {
                    type: this.type,
                };
                axios
                    .post("/Webinar/validatefile", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.imagesize = res.data.imagesize;
                            if (file_size > this.imagesize) {
                                //200kb
                                this.videoSizeFlag = true;
                                this.videoUpload = null;
                                this.showSnackbar("#b71c1c", "File Size should be less than or equal to ..." + this.imagesize + "KB");
                            } else {
                                this.videoSizeFlag = false;
                            }
                            this.imagetype = res.data.imagetype;
                            //console.log(this.imagetype)
                            for (var i = 0; i < this.imagetype.length; i++) {
                                //alert(i)
                                //alert(this.imagetype[i].imagetype)
                                if (ext == this.imagetype[i].imagetype) {
                                    // alert("in if")
                                    this.videoTypeFlag = false;
                                    return;
                                }
                            }
                            for (var i = 0; i < this.imagetype.length; i++) {
                                if (ext != this.imagetype[i].imagetype) {
                                    // alert("in else new for")
                                    this.videoTypeFlag = true;
                                    this.videoUpload = null;
                                    this.showSnackbar("#b71c1c", "File type should be " + this.imagetype[i].imagetype);
                                    return;
                                }
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.onerror(error);
                        window.console.log(error);

                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    });
            },
            vUpload() {
                document.getElementById("vUpload").click();
            },
            uploadvideo(wevinarId) {
                //alert("uploadvideo::" + wevinarId)
                this.wid = wevinarId;
                this.dialog_uploadvideo = true;
                //return
            },
            uploadvideo1(wid) {
                let formData = new FormData();
                formData.append("videoUpload", this.videoUpload);
                formData.append("wid", wid);
                this.loader = true;
                axios
                    .post("/Webinar/uploadVideo", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.dialog_uploadvideo = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                        this.dialog_uploadvideo = false;
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        this.dialog_uploadvideo = false;
                    });
            },
            getwebinarattendance(item) {
                const data = {
                    coff_id: this.coff_id,
                    ay: this.ay,
                    wid: item,
                };
                axios
                    .post("/Webinar/getAttandanceMatrix", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learnerprogress = res.data.learnerprogress;
                            this.dialog_showattendance = true;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            editWebinar(item) {
                const data = {
                    wid: item.wid,
                };
                axios
                    .post("/Webinar/editwebinar", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.title = res.data.webinar_data[0].title;
                            this.description = res.data.webinar_data[0].description;
                            // this.date = res.data.webinar_data[0].startDate;
                            var momentDate = moment(res.data.webinar_data[0].start_date);
                            var end_date = moment(res.data.webinar_data[0].end_date);
                            //alert(end_date)
                            this.date = momentDate.toDate();
                            this.end_date = end_date.toDate();
                            this.fromtime = res.data.webinar_data[0].startTime;
                            this.totime = res.data.webinar_data[0].endTime;
                            this.webinarlink = res.data.webinar_data[0].webinar_link;
                            this.wid = res.data.webinar_data[0].wid;
                            // this.end_date = res.data.webinar_data[0].endDate;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            copywebinar(item) {
                const data = {
                    wid: item,
                };
                axios
                    .post("/Webinar/editwebinar", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dialog_copywebinar = true;
                            this.title = res.data.webinar_data[0].title;
                            this.description = res.data.webinar_data[0].description;
                            // this.date = res.data.webinar_data[0].startDate;
                            // this.fromtime = res.data.webinar_data[0].startTime;
                            // this.totime = res.data.webinar_data[0].endTime;
                            var momentDate = moment(res.data.webinar_data[0].start_date);
                            var end_date = moment(res.data.webinar_data[0].end_date);
                            this.date = momentDate.toDate();
                            this.end_date = end_date.toDate();
                            this.webinarlink = res.data.webinar_data[0].webinar_link;
                            this.wid = res.data.webinar_data[0].wid;
                            this.end_date = res.data.webinar_data[0].endDate;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            toggle(item) {
                const data = {
                    wid: item.wid,
                    webinar_status: item.isactive,
                };
                axios
                    .post("/Webinar/isctivewebinar", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Webinar Updated Successfully..");
                            this.onload();
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            reset() {
                (this.title = null), (this.description = null), (this.date = null), (this.end_date = null), (this.webinarlink = null), (this.fromtime = null), (this.totime = null);
            },
            savewebinar_copy() {
                var start_date = moment(this.date).format("YYYY-MM-DD HH:mm");
                var end_date = moment(this.end_date).format("YYYY-MM-DD HH:mm");
                const data = {
                    title: this.title,
                    description: this.description,
                    //date: this.date,
                    start_date: start_date,
                    end_date: end_date,
                    webinarlink: this.webinarlink,
                    // fromtime: this.fromtime,
                    // totime: this.totime,
                    coff_id: this.coff_id,
                    ay: this.ay,
                    crs_off_inst_id: this.crs_off_inst_id,
                };
                axios
                    .post("/Webinar/savewebinar", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Webinar Saved Successfully..");
                            this.onload();
                            this.publishLoader = false;
                            this.dialog_copywebinar = false;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "Webinar Already Present");
                            this.publishLoader = false;
                            this.dialog_copywebinar = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.publishLoader = false;
                        this.dialog_copywebinar = false;
                    })
                    .finally(() => {
                        //close loader
                        this.publishLoader = false;
                        this.dialog_copywebinar = false;
                        (this.title = null), (this.description = null), (this.date = null), (this.webinarlink = null), (this.fromtime = null), (this.totime = null);
                    });
            },
            savewebinar() {
                this.publishLoader = true;
                if (this.wid != null) {
                    var start_date = moment(this.date).format("YYYY-MM-DD HH:mm");
                    var end_date = moment(this.end_date).format("YYYY-MM-DD HH:mm");
                    const data = {
                        title: this.title,
                        description: this.description,
                        //  date: this.date,
                        start_date: start_date,
                        end_date: end_date,
                        webinarlink: this.webinarlink,
                        // fromtime: this.fromtime,
                        // totime: this.totime,
                        coff_id: this.coff_id,
                        ay: this.ay,
                        crs_off_inst_id: this.crs_off_inst_id,
                        wid: this.wid,
                    };
                    axios
                        .post("/Webinar/saveeditwebinar", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4CAF50", "Webinar Edited Successfully..");
                                this.onload();
                                this.publishLoader = false;
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something Went Wrong");
                            this.publishLoader = false;
                        })
                        .finally(() => {
                            //close loader
                            this.publishLoader = false;
                            this.reset();
                            (this.title = null), (this.description = null), (this.date = null), (this.end_date = null), (this.webinarlink = null), (this.fromtime = null), (this.totime = null), (this.wid = null);
                        });
                } else {
                    var start_date = moment(this.date).format("YYYY-MM-DD HH:mm");
                    var end_date = moment(this.end_date).format("YYYY-MM-DD HH:mm");
                    const data = {
                        title: this.title,
                        description: this.description,
                        // date: this.date,
                        start_date: start_date,
                        end_date: end_date,
                        webinarlink: this.webinarlink,
                        // fromtime: this.fromtime,
                        // totime: this.totime,
                        coff_id: this.coff_id,
                        ay: this.ay,
                        crs_off_inst_id: this.crs_off_inst_id,
                    };
                    axios
                        .post("/Webinar/savewebinar", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4CAF50", "Webinar Saved Successfully..");
                                this.onload();
                                this.publishLoader = false;
                            }
                            if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", "Webinar Already Present");
                                this.publishLoader = false;
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something Went Wrong");
                            this.publishLoader = false;
                        })
                        .finally(() => {
                            //close loader
                            this.publishLoader = false;
                            this.reset();
                            (this.title = null), (this.description = null), (this.date = null), (this.end_date = null), (this.webinarlink = null), (this.fromtime = null), (this.totime = null);
                        });
                }
            },
            validateWebinarURL(link) {
                var myURL = link;
                var mytrimurl = myURL.trim();
                var pattern = new RegExp(
                    "^((ft|htt)ps?:\\/\\/)?" + // protocol
                    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                    "(\\:\\d+)?" + // port
                    "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                    "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                        "(\\#[-a-z\\d_]*)?$",
                    "i"
                ); // fragment locator');
                if (pattern.test(mytrimurl)) {
                    this.isvalid = true;
                    return;
                } else {
                    this.showSnackbar("#b71c1c", "Please Enter Valid URL...!");
                    this.isvalid = false;
                    this.webinarlink = null;
                    return;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const formData = {
                    coff_id: this.coff_id,
                    crs_off_inst_id: this.crs_off_inst_id,
                    ay: this.ay,
                };
                axios
                    .post("/Webinar/getCourseWebinar", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.webinarlist = res.data.webinarlist;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    input[type="time"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .video-section {
        padding: 0rem 0rem 0rem 2rem;
    }

    .video-title {
        border: 1px solid #0f2027;
        padding: 0.6rem 1.2rem 0.4rem 1.2rem;
        border-top-right-radius: 20px;
        background: #0f2027;
        border-top-left-radius: 20px;
        color: white;
    }

    .video-panel {
        border: 2px solid #0f2027;
        padding: 1rem;
        margin-top: 1rem;
        text-align: center;
        min-height: 7.5rem;
    }
         .breadcrumb {
    
             padding: 10px;
    
             margin-left: 80px;
             margin-top: -50px;
             font-size: medium;
             font-weight: bold;
         }
</style>
